import React from 'react';
import { Fund } from 'src/components/Exchange/types';
import If from 'src/components/Shared/If/If';
import { SystemCode } from 'src/settings/settings';
import { checkMissingFeaturesByCode } from 'src/utils/funds/shared/shared-fund-notes-utility';
import words from 'src/utils/words';
import config from '../../../../config/config';

export interface CheckRedemptionFundNoteTipProps {
  fund: Fund;
  phoneNumber?: string;
}

const CheckRedemptionFundNoteTip: React.FC<CheckRedemptionFundNoteTipProps> = ({
  fund,
  phoneNumber = '(800) 225-5132',
}) => (
  <div className="exclude">
    <span className="exclude">
      {' '}
      Check {words.Redemption}s are unavailable.{' '}
    </span>
    <If test={checkMissingFeaturesByCode(fund, SystemCode.WIRE_REDEMPTION)}>
      Try {words.redeeming} via Direct Deposit,
    </If>
    <If test={checkMissingFeaturesByCode(fund, SystemCode.ACH_REDEMPTION)}>
      Try {words.redeeming} via Wire,
    </If>
    <If
      test={
        !checkMissingFeaturesByCode(fund, SystemCode.ACH_REDEMPTION) &&
        !checkMissingFeaturesByCode(fund, SystemCode.WIRE_REDEMPTION)
      }
    >
      Try {words.redeeming} via Direct Deposit or Wire,
    </If>
    <span className="exclude">
      {' '}
      or{' '}
      <a
        href={`${config.url}/personal-investing/help/contact/index.html`}
        rel="noopener noreferrer"
        target="_blank"
      >
        contact us
      </a>{' '}
      to discuss your options with an associate.{' '}
    </span>
  </div>
);

export default CheckRedemptionFundNoteTip;
